<template>
  <div class="mt-4" style="overflow: auto;">
    <h1 class="mb-4 text-center">Termine</h1>
    <div v-for="(attendanceDay, index) in attendanceDays" :key="index" class="mt-4">
      <strong class="mt-3">{{ attendanceDay.displayMonth }}</strong>
      <b-list-group>
        <b-list-group-item v-for="(content, index) in attendanceDay.content" :key="index" class="d-flex justify-content-between align-items-center" v-b-modal.modal-attendance @click="changeDate(content.date)" :variant="content.cancelled ? 'danger' : ''">
          <span :class="{ 'text-decoration-line-through': content.cancelled }">
            {{ content.formattedDate }} - {{ content.title }}
          </span>
          <span v-if="content.cancelled" class="cancelled-badge">Abgesagt</span>
          <b-icon v-else icon="chevron-right"></b-icon>
        </b-list-group-item>
      </b-list-group>
    </div>
    <b-modal id="modal-attendance" hide-footer scrollable>
      <AttendanceShowContainer :date="this.date"></AttendanceShowContainer>
      <template #modal-header>
        <b-icon icon="chevron-left" @click="$bvModal.hide('modal-attendance')"></b-icon>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AttendanceShowContainer from '@/components/attendanceShowContainer.vue';
import axios from 'axios';

export default {
  name: "attendanceView",
  components: {
    AttendanceShowContainer
  },
  data() {
    return {
      attendanceDays: [],

      date: null,

      apiUrl: process.env.VUE_APP_API_URL,

      termine: [
        { name: 'Besprechung mit Team', abgesagt: false },
        { name: 'Arzttermin', abgesagt: true },
        { name: 'Projektabgabe', abgesagt: false },
      ],
    };
  },

  computed: {
  },

  methods: {
    changeDate(date) {
      this.date = date;
    }
  },

  beforeMount() {
    axios.get(this.apiUrl + '/attendance')
      .then((response) => {
        this.attendanceDays =  Object.values(response.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);

        if (error.status === 401) {
          localStorage.removeItem('token');
        } 
      });
  },
};
</script>

<style scoped>
.text-decoration-line-through {
  text-decoration: line-through;
}

.cancelled-badge {
  background-color: #ffdddd;
  color: #a60000;
  padding: 4px 10px;
  font-size: 0.8rem;
  font-weight: bold;
  border-radius: 12px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  display: inline-block;
}
</style>
